import type { FormItem } from 'form/types';

const step: FormItem[] = [
  {
    type: 'checkbox',
    id: 'crib-best-practice',
    label:
      'My site can return to 100 per cent of their workforce if my crib rooms have best practice approaches including ventilation and density limits'
  },
  {
    type: 'checkbox',
    id: 'best-practice-cribs',
    label:
      'All crib rooms on site will follow the best practice ventilation guidelines including density limit of 1 per person per 4sqm; and additional ventilation so that entire air volume of the room is replaced or filtered every 10 to 12 minutes.'
  },
  {
    type: 'checkbox',
    id: 'record-movements',
    label:
      'I will keep records showing any workers moving between metropolitan Melbourne and regional Victoria have evidence of at least one vaccination dose (or evidence of medical exception).'
  },
  {
    type: 'checkbox',
    id: 'single-vacc-testing',
    label:
      'I will make sure any single-vaccinated workers moving between metropolitan Melbourne and regional Victoria will be tested before crossing the boundary and they must get tested twice a week, with at least 72 hours between each test.'
  }
];

export default step;
